/* =========================================================
   RoyalArt — theme.js
   Header · mobile nav · mega-menu · search · accordions
   · scroll reveal · announcement rotation
   No dependencies. Defer-loaded.
   ========================================================= */
(function () {
  "use strict";

  var root = document.documentElement;
  var body = document.body;

  /* ---------- helpers ---------- */
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var scrollLockCount = 0;
  function lockScroll() { scrollLockCount++; body.classList.add("is-locked"); }
  function unlockScroll() { scrollLockCount = Math.max(0, scrollLockCount - 1); if (!scrollLockCount) body.classList.remove("is-locked"); }

  /* ---------- Sticky header (subtle shrink) ---------- */
  function stickyHeader() {
    var header = $("[data-header]");
    if (!header) return;
    var last = 0;
    function update() {
      var y = window.scrollY || window.pageYOffset;
      header.classList.toggle("is-shrunk", y > 24);
      last = y;
    }
    update();
    on(window, "scroll", function () { window.requestAnimationFrame(update); }, { passive: true });
  }

  /* ---------- Off-canvas panels (mobile nav, search) ---------- */
  function panels() {
    $all("[data-panel-open]").forEach(function (btn) {
      on(btn, "click", function () { openPanel(btn.getAttribute("data-panel-open")); });
    });
    $all("[data-panel-close]").forEach(function (btn) {
      on(btn, "click", function () { closePanel(btn.closest("[data-panel]")); });
    });
    $all("[data-panel]").forEach(function (p) {
      on(p, "click", function (e) { if (e.target.hasAttribute("data-panel-overlay")) closePanel(p); });
    });
    on(document, "keydown", function (e) {
      if (e.key === "Escape") { var open = $(".is-open[data-panel]"); if (open) closePanel(open); }
    });
  }
  function openPanel(id) {
    var p = document.getElementById(id);
    if (!p) return;
    p.classList.add("is-open");
    p.setAttribute("aria-hidden", "false");
    lockScroll();
    var focusable = p.querySelector("input, button, a, [tabindex]");
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }
  function closePanel(p) {
    if (!p || !p.classList.contains("is-open")) return;
    p.classList.remove("is-open");
    p.setAttribute("aria-hidden", "true");
    unlockScroll();
  }
  window.RoyalArt = window.RoyalArt || {};
  window.RoyalArt.openPanel = openPanel;
  window.RoyalArt.closePanel = closePanel;

  /* ---------- Mega-menu (desktop hover via CSS; keyboard + mobile here) ---------- */
  function megaMenu() {
    $all("[data-mega-trigger]").forEach(function (trigger) {
      var item = trigger.closest("[data-mega]");
      on(trigger, "click", function (e) {
        // mobile / keyboard toggle
        if (window.matchMedia("(max-width: 1024px)").matches || trigger.getAttribute("data-mega-trigger") === "tap") {
          e.preventDefault();
          var expanded = trigger.getAttribute("aria-expanded") === "true";
          closeAllMega();
          if (!expanded) { item.classList.add("is-open"); trigger.setAttribute("aria-expanded", "true"); }
        }
      });
    });
    on(document, "keydown", function (e) { if (e.key === "Escape") closeAllMega(); });
    on(document, "click", function (e) { if (!e.target.closest("[data-mega]")) closeAllMega(); });
  }
  function closeAllMega() {
    $all("[data-mega].is-open").forEach(function (i) {
      i.classList.remove("is-open");
      var t = i.querySelector("[data-mega-trigger]");
      if (t) t.setAttribute("aria-expanded", "false");
    });
  }

  /* ---------- Accordions ---------- */
  function accordions() {
    $all("[data-accordion]").forEach(function (group) {
      var single = group.hasAttribute("data-accordion-single");
      $all(".accordion__trigger", group).forEach(function (trigger) {
        var panel = document.getElementById(trigger.getAttribute("aria-controls"));
        if (!panel) return;
        on(trigger, "click", function () {
          var isOpen = trigger.getAttribute("aria-expanded") === "true";
          if (single) {
            $all(".accordion__trigger", group).forEach(function (t) {
              if (t !== trigger) { t.setAttribute("aria-expanded", "false"); collapse(document.getElementById(t.getAttribute("aria-controls"))); }
            });
          }
          trigger.setAttribute("aria-expanded", String(!isOpen));
          if (isOpen) collapse(panel); else expand(panel);
        });
      });
    });
  }
  function expand(panel) {
    panel.style.height = panel.scrollHeight + "px";
    panel.addEventListener("transitionend", function done() {
      panel.style.height = "auto";
      panel.removeEventListener("transitionend", done);
    });
  }
  function collapse(panel) {
    if (!panel) return;
    panel.style.height = panel.scrollHeight + "px";
    void panel.offsetHeight;
    panel.style.height = "0px";
  }

  /* ---------- Scroll reveal ---------- */
  function reveal() {
    var els = $all("[data-reveal]");
    if (!els.length || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = el.getAttribute("data-reveal-delay");
          if (delay) el.style.transitionDelay = delay + "ms";
          el.classList.add("is-visible");
          io.unobserve(el);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Announcement rotation ---------- */
  function announcement() {
    $all("[data-announcement]").forEach(function (bar) {
      var slides = $all("[data-announcement-slide]", bar);
      if (slides.length < 2) return;
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove("is-active");
        i = (i + 1) % slides.length;
        slides[i].classList.add("is-active");
      }, 4200);
    });
  }

  /* ---------- Collection: sort + client-side facet filtering ---------- */
  function collection() {
    /* Sort still uses Shopify (server reload). */
    var sort = $("[data-sort]");
    if (sort) {
      on(sort, "change", function () {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", sort.value);
        url.searchParams.delete("page");
        window.location.href = url.toString();
      });
    }

    /* Wheel over the sticky sidebar scrolls the sidebar itself (the page uses
       body as its scroll container, which otherwise swallows nested wheel
       scrolling). Hands back to the page at the top/bottom edges. */
    var sidebar = $(".filters--desktop");
    if (sidebar) {
      on(sidebar, "wheel", function (e) {
        if (sidebar.scrollHeight <= sidebar.clientHeight) return; /* nothing to scroll */
        var dy = e.deltaY * (e.deltaMode === 1 ? 16 : 1);
        var atTop = sidebar.scrollTop <= 0;
        var atBottom = sidebar.scrollTop + sidebar.clientHeight >= sidebar.scrollHeight - 1;
        if ((dy < 0 && atTop) || (dy > 0 && atBottom)) return; /* let the page scroll */
        sidebar.scrollTop += dy;
        e.preventDefault();
      }, { passive: false });
    }

    /* "Show more" (•••) inside long filter groups. */
    $all("[data-filter-more]").forEach(function (btn) {
      on(btn, "click", function () {
        var panel = btn.closest(".filter-group__panel");
        if (!panel) return;
        $all("[data-filter-extra]", panel).forEach(function (el) { el.removeAttribute("hidden"); });
        btn.classList.add("is-open");
      });
    });

    /* Client-side facets — no app, no reload. */
    var grid = $("[data-facet-grid]");
    if (!grid) return;
    var cards = $all("[data-card]", grid);
    var countEl = $("[data-result-count]");
    var pluralEl = $("[data-result-plural]");
    var emptyEl = $("[data-no-results]");

    function checkedValues(facet) {
      var seen = {};
      $all('[data-facet-input="' + facet + '"]:checked').forEach(function (i) { seen[i.value] = 1; });
      return Object.keys(seen);
    }
    function priceVal(which) {
      var el = $('[data-facet-price="' + which + '"]');
      if (!el || el.value === "") return null;
      var n = parseFloat(el.value);
      return isNaN(n) ? null : n * 100; /* rupees -> cents */
    }
    function matchAny(attr, values) {
      if (!values.length) return true;
      for (var i = 0; i < values.length; i++) { if (attr.indexOf("~" + values[i] + "~") > -1) return true; }
      return false;
    }

    function apply() {
      var rooms = checkedValues("room");
      var themes = checkedValues("theme");
      var inStock = checkedValues("available").length > 0;
      var pmin = priceVal("min");
      var pmax = priceVal("max");
      var shown = 0;

      cards.forEach(function (card) {
        var ok = matchAny(card.getAttribute("data-room") || "", rooms)
              && matchAny(card.getAttribute("data-theme") || "", themes);
        if (ok && inStock) ok = card.getAttribute("data-available") === "1";
        if (ok && (pmin !== null || pmax !== null)) {
          var price = parseInt(card.getAttribute("data-price"), 10) || 0;
          if (pmin !== null && price < pmin) ok = false;
          if (pmax !== null && price > pmax) ok = false;
        }
        card.hidden = !ok;
        if (ok) shown++;
      });

      if (countEl) countEl.textContent = shown;
      if (pluralEl) pluralEl.textContent = shown === 1 ? "" : "s";
      if (emptyEl) emptyEl.hidden = shown !== 0;

      /* Toggle each group's Reset link based on whether it has an active selection. */
      $all("[data-facet-reset]").forEach(function (btn) {
        var facet = btn.getAttribute("data-facet-reset");
        var active = facet === "price"
          ? (pmin !== null || pmax !== null)
          : checkedValues(facet).length > 0;
        btn.hidden = !active;
      });
    }

    /* Mirror a control across the desktop sidebar + mobile drawer so both stay in sync. */
    function syncCheckbox(input) {
      $all('[data-facet-input="' + input.getAttribute("data-facet-input") + '"]').forEach(function (i) {
        if (i.value === input.value) i.checked = input.checked;
      });
    }
    function syncPrice(input) {
      $all('[data-facet-price="' + input.getAttribute("data-facet-price") + '"]').forEach(function (i) {
        if (i !== input) i.value = input.value;
      });
    }

    $all("[data-facet-input]").forEach(function (input) {
      on(input, "change", function () { syncCheckbox(input); apply(); });
    });
    $all("[data-facet-price]").forEach(function (input) {
      on(input, "input", function () { syncPrice(input); apply(); });
    });

    function resetFacet(facet) {
      if (facet === "price") {
        $all("[data-facet-price]").forEach(function (i) { i.value = ""; });
      } else {
        $all('[data-facet-input="' + facet + '"]').forEach(function (i) { i.checked = false; });
      }
    }
    $all("[data-facet-reset]").forEach(function (btn) {
      on(btn, "click", function () { resetFacet(btn.getAttribute("data-facet-reset")); apply(); });
    });
    $all("[data-facet-clear-all]").forEach(function (btn) {
      on(btn, "click", function () {
        $all("[data-facet-input]").forEach(function (i) { i.checked = false; });
        $all("[data-facet-price]").forEach(function (i) { i.value = ""; });
        apply();
      });
    });

    apply();
  }

  /* ---------- Rails: swipe progress bar (phones/tablets, where the arrows are hidden) ----------
     A gold thumb under each rail tracks the scroll position and can be dragged. The first
     time a rail comes into view it nudges sideways once, so shoppers see that it slides. */
  function railProgress(rail, wrap) {
    var bar = document.createElement("div");
    bar.className = "rail-progress";
    bar.setAttribute("aria-hidden", "true");
    bar.innerHTML = '<span class="rail-progress__track"><span class="rail-progress__thumb"></span></span>' +
      '<span class="rail-progress__hint">Swipe<svg viewBox="0 0 16 10" width="14" height="9" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M1 5h13M10 1l4 4-4 4"/></svg></span>';
    wrap.appendChild(bar);
    var track = bar.firstChild;
    var thumb = track.firstChild;
    var touched = false;
    on(rail, "pointerdown", function () { touched = true; }, { passive: true });
    on(rail, "touchstart", function () { touched = true; }, { passive: true });

    function paint() {
      var max = rail.scrollWidth - rail.clientWidth;
      bar.hidden = max <= 1;
      if (max <= 1) return;
      var tw = Math.max(rail.clientWidth / rail.scrollWidth, 0.14);
      var p = Math.min(Math.max(rail.scrollLeft / max, 0), 1);
      thumb.style.width = tw * 100 + "%";
      /* translate % is relative to the thumb itself, so scale the travel by 1/tw */
      thumb.style.transform = "translateX(" + (p * (1 - tw) / tw) * 100 + "%)";
      /* the "Swipe" hint has done its job once the shopper has moved the rail themselves */
      if (touched && rail.scrollLeft > 8) bar.classList.add("is-used");
    }
    on(rail, "scroll", function () { requestAnimationFrame(paint); }, { passive: true });
    on(window, "resize", paint);
    paint();

    /* drag / tap on the bar scrolls the rail; snapping is paused mid-drag so it follows the finger */
    var dragging = false;
    function seek(e) {
      var r = track.getBoundingClientRect();
      var p = Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1);
      rail.scrollLeft = p * (rail.scrollWidth - rail.clientWidth);
    }
    on(bar, "pointerdown", function (e) {
      dragging = true;
      touched = true;
      bar.classList.add("is-dragging");
      rail.style.scrollSnapType = "none";
      if (bar.setPointerCapture) bar.setPointerCapture(e.pointerId);
      seek(e);
    });
    on(bar, "pointermove", function (e) { if (dragging) seek(e); });
    function end() {
      if (!dragging) return;
      dragging = false;
      bar.classList.remove("is-dragging");
      rail.style.scrollSnapType = "";
    }
    on(bar, "pointerup", end);
    on(bar, "pointercancel", end);

    /* one-time sideways nudge when the rail first scrolls into view */
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      if (window.innerWidth > 1024 || rail.scrollLeft > 0 || bar.hidden) return;
      setTimeout(function () {
        if (touched || rail.scrollLeft > 0) return;
        rail.style.scrollSnapType = "none";
        rail.scrollTo({ left: 64, behavior: "smooth" });
        setTimeout(function () { if (!touched) rail.scrollTo({ left: 0, behavior: "smooth" }); }, 550);
        setTimeout(function () { if (!dragging) rail.style.scrollSnapType = ""; }, 1200);
      }, 500);
    }, { threshold: 0.6 });
    io.observe(rail);
  }

  /* ---------- Watch & buy: arrow scrolling ---------- */
  function videoRail() {
    $all("[data-vbuy-rail]").forEach(function (rail) {
      var wrap = rail.closest(".vbuy__wrap");
      if (!wrap) return;
      var prev = $("[data-vbuy-prev]", wrap);
      var next = $("[data-vbuy-next]", wrap);

      function step() {
        var card = rail.querySelector(".vbuy__card") || rail.firstElementChild;
        var w = card ? card.getBoundingClientRect().width : 240;
        return (w + 16) * 2; /* scroll roughly two cards */
      }
      function refresh() {
        var max = rail.scrollWidth - rail.clientWidth - 1;
        var overflow = max > 0;
        if (prev) prev.hidden = !overflow;
        if (next) next.hidden = !overflow;
        if (!overflow) return;
        /* keep both arrows visible; dim the one that can't move further */
        if (prev) prev.disabled = rail.scrollLeft <= 0;
        if (next) next.disabled = rail.scrollLeft >= max;
      }
      if (prev) on(prev, "click", function () { rail.scrollBy({ left: -step(), behavior: "smooth" }); });
      if (next) on(next, "click", function () { rail.scrollBy({ left: step(), behavior: "smooth" }); });
      on(rail, "scroll", refresh, { passive: true });
      on(window, "resize", refresh);
      refresh();
      railProgress(rail, wrap);

      /* only fetch + play the clips actually on screen — the rail can hold 20+ */
      var vids = $all("[data-vbuy-video]", rail);
      if (!vids.length) return;
      if (!("IntersectionObserver" in window)) {
        vids.forEach(function (v) { if (v.dataset.src) v.src = v.dataset.src; });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (!v.getAttribute("src") && v.dataset.src) v.src = v.dataset.src;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { rootMargin: "300px", threshold: 0.2 });
      vids.forEach(function (v) { io.observe(v); });
    });
  }

  /* ---------- Hero slideshow (crossfade + dots + swipe + autoplay) ---------- */
  function heroSlider() {
    $all("[data-hero-slider]").forEach(function (root) {
      var slides = $all("[data-hero-slide]", root);
      if (slides.length < 1) return;

      var viewport = $("[data-hero-viewport]", root);
      var dotsWrap = $("[data-hero-dots]", root);
      var prevBtn = $("[data-hero-prev]", root);
      var nextBtn = $("[data-hero-next]", root);
      var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var i = 0;
      var timer = null;

      var autoplay = root.getAttribute("data-autoplay") !== "false" && slides.length > 1 && !reduce;
      var interval = parseInt(root.getAttribute("data-interval"), 10) || 6000;

      /* dots */
      var dots = slides.map(function (_, idx) {
        var d = document.createElement("button");
        d.type = "button";
        d.className = "hero-slider__dot" + (idx === 0 ? " is-active" : "");
        d.setAttribute("role", "tab");
        d.setAttribute("aria-label", "Go to slide " + (idx + 1));
        on(d, "click", function () { go(idx, true); });
        if (dotsWrap) dotsWrap.appendChild(d);
        return d;
      });

      /* hide single-slide controls */
      if (slides.length < 2) {
        if (prevBtn) prevBtn.style.display = "none";
        if (nextBtn) nextBtn.style.display = "none";
        if (dotsWrap) dotsWrap.style.display = "none";
        return;
      }

      function go(n, fromUser) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, idx) {
          s.classList.toggle("is-active", idx === i);
          s.setAttribute("aria-hidden", idx === i ? "false" : "true");
        });
        dots.forEach(function (d, idx) {
          d.classList.toggle("is-active", idx === i);
          d.setAttribute("aria-selected", idx === i ? "true" : "false");
        });
        if (fromUser) restart();
      }
      function next() { go(i + 1); }
      function prev() { go(i - 1); }

      function start() { if (autoplay) timer = window.setInterval(next, interval); }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }

      on(nextBtn, "click", function () { go(i + 1, true); });
      on(prevBtn, "click", function () { go(i - 1, true); });

      /* pause on hover / focus within */
      on(root, "mouseenter", stop);
      on(root, "mouseleave", start);
      on(root, "focusin", stop);
      on(root, "focusout", start);

      /* pause when offscreen */
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
        }, { threshold: 0.2 }).observe(root);
      }

      /* touch swipe */
      var x0 = null;
      on(viewport, "touchstart", function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      on(viewport, "touchend", function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) (dx < 0 ? next : prev)();
        x0 = null;
        start();
      }, { passive: true });

      start();
    });
  }

  /* ---------- init ---------- */
  function init() {
    stickyHeader();
    panels();
    megaMenu();
    accordions();
    reveal();
    announcement();
    collection();
    videoRail();
    heroSlider();
  }

  if (document.readyState === "loading") on(document, "DOMContentLoaded", init);
  else init();
})();
